// extracted by mini-css-extract-plugin
export default {"modalContent":"CostTrendModal_modalContent__qyJ2J"};